import { z } from "zod";
/**
 * Recorte de listagem — parâmetros e envelope.
 *
 * Atravessa a fronteira API ↔ web, por isso nasce aqui (Princípio I): o tipo
 * sai de `@atlas/types`, sobe pelo `@atlas/sdk` e a web consome.
 *
 * A REGRA QUE MAIS IMPORTA está codificada no `.optional()` do `limit`:
 * **ausente = lista inteira, exatamente como hoje**. As rotas que recebem estes
 * parâmetros já têm consumidores; passar a devolver uma página por default
 * entregaria relatório incompleto SEM ERRO NENHUM — nada quebra, nada avisa, os
 * números só ficam menores. É a classe de defeito mais cara que existe, e a
 * única defesa é o default não mudar.
 *
 * O que este contrato NÃO promete: alívio de banco ou de memória do Worker. As
 * listagens hidratam coleções inteiras em memória a cada request, por razões
 * que resolveram bugs reais de race e de cálculo de margem. `limit` reduz o que
 * trafega e o que o navegador processa — que é o gargalo do usuário.
 */
export const RecorteParamsSchema = z.object({
    /** Ausente = lista inteira (comportamento atual). Cada rota impõe seu teto. */
    limit: z.number().int().positive().optional(),
    /** Deslocamento dentro do recorte JÁ filtrado. */
    offset: z.number().int().min(0).optional(),
});
/**
 * Total do recorte, devolvido AO LADO da lista quando `limit` está presente.
 *
 * A lista mantém o nome que cada rota já usa (`servidores`, `contratos`, …) —
 * renomear para algo genérico quebraria todo consumidor por nenhum ganho. Por
 * isso o envelope é este campo solto, e não um `{ itens, total }`.
 */
export const TotalDoRecorteSchema = z.object({
    /** Registros do recorte ANTES do fatiamento. Sem ele a tela não sabe quantas páginas existem. */
    total: z.number().int().min(0),
});
/** Default do produto — o mesmo que as telas que já paginam praticam. */
export const RECORTE_LIMIT_PADRAO = 25;
/**
 * Teto por rota, no precedente de `/v1/admin/auditoria` (default 200, teto 500).
 *
 * Pedido acima do teto é LIMITADO ao teto, nunca recusado: recusar
 * transformaria um exagero inofensivo em erro de tela.
 */
export const RECORTE_LIMIT_MAXIMO = 500;
/** Aplica o teto. Use no servidor, onde o valor chega de fora. */
export function limitarRecorte(limit, maximo = RECORTE_LIMIT_MAXIMO) {
    if (limit === undefined || !Number.isFinite(limit))
        return undefined;
    const n = Math.trunc(limit);
    if (n <= 0)
        return undefined;
    return Math.min(n, maximo);
}
//# sourceMappingURL=paginacao.js.map